/* eslint-disable react/jsx-no-bind */
import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { Slider } from '../Slider';
import { Article } from './types';
import { PostCard } from '../PostCard';

interface IArticlesTable {
  className?: string;
  articles: Article[];
}

export const StyledArticlesTable = styled.div`
  width: 100%;

  .article-slide {
    padding: 0 ${rem(`16px`)};
    ${({ theme }) => theme.breakpoints.desktop`
      padding: 0 ${rem(`24px`)};
    `}
  }
  .slick-slider {
    padding: 0;
    .slick-list {
      margin: 0 ${rem(`-16px`)};
      padding: 0;
      ${({ theme }) => theme.breakpoints.desktop`
          margin: 0 ${rem(`-24px`)};
      `}
    }
  }
  .slick-track {
    padding: 0 0 ${rem(`24px`)};
    ${({ theme }) => theme.breakpoints.desktop`
      padding: ${rem(`32px`)} 0;
    `}
  }
`;

export const ArticlesTable = ({ articles, className }: IArticlesTable) => {
  const settingsSlider = {
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
  };

  const settingsSliderPhoneResponsive = {
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const settingsSliderPhabletResponsive = {
    slidesToShow: 2,
    slidesToScroll: 1,
  };

  const settingsSliderTabletResponsive = {
    slidesToShow: 2,
    slidesToScroll: 1,
  };

  return (
    <StyledArticlesTable className={className}>
      <Slider
        className="articles-slider"
        settings={settingsSlider}
        responsivePhoneSettings={settingsSliderPhoneResponsive}
        responsivePhabletSettings={settingsSliderPhabletResponsive}
        responsiveTabletSettings={settingsSliderTabletResponsive}
        paginationMargin="24px"
      >
        {articles.map(({ createDate, ...rest }: Article) => (
          <div className="article-slide" key={rest.title}>
            <PostCard vertical date={createDate} {...rest} />
          </div>
        ))}
      </Slider>
    </StyledArticlesTable>
  );
};
